import Image from "next/image";
import winnerTrophy from "../../../public/assets/images/winners-trophy.png";
import bg from "../../../public/assets/images/hero-trophy.png";

// interface dataProps {}

export default function FirstWinner({ data }) {
  const year = data.winner.title;
  return (
    <div className="w-full md:flex items-center lg:gap-24 py-8">
      <div className="w-full md:w-1/2">
        <h1 className="text-red-main">{data.winner.title}</h1>
        <h2 className="text-5xl pt-6 pb-3">{data.winner.name}</h2>
        <h3 className="italic text-gray-600">{data.winner.business}</h3>
        <p className="py-4 md:py-10">
          Le CJD Tunisie et La Konrad-Adenauer-Stiftung ont organisé la
          cérémonie de remise des prix de cette édition des CJD Business Awards{" "}
          {year.slice(year.length - 4)}, un concours qui récompense depuis 2008
          les meilleurs jeunes dirigeants de l’année. Le Prix du meilleur JD de
          l’année {year.slice(year.length - 4)} a été décerné à:{" "}
          {data.winner.name} de {data.winner.business}
        </p>
      </div>
      <div className="w-full hidden md:w-1/2 md:flex md:justify-center items-end py-4">
        <div className="relative">
          <Image
            src={winnerTrophy}
            placeholder="blur"
            alt="Hero trophy"
            width={260}
            height={386}
          />
        </div>
        <div className="absolute left-2/3">
          <Image
            src={bg}
            placeholder="blur"
            alt="Hero trophy background"
            width={429}
            height={514}
          />
        </div>
      </div>
    </div>
  );
}
